import { render, staticRenderFns } from "./IntercomsTable.vue?vue&type=template&id=378e7800&"
import script from "./IntercomsTable.vue?vue&type=script&lang=js&"
export * from "./IntercomsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports